// Dependencies
import * as zod from "zod";

// Config
import { BACKEND_API } from "@/project.config";

// Libs
import { CreateAccountSchema } from "@/lib/zod";

export async function createAccount(
  values: zod.infer<typeof CreateAccountSchema>
): Promise<Response> {
  const response = await fetch(`${BACKEND_API}/auth/`, {
    method: "POST",
    body: JSON.stringify(values),
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
}
